module.exports = __webpack_public_path__ + "img/v1-3.4afc9bdf.png";